import "./services.css";
import { Container, Header, Grid, Icon } from "semantic-ui-react";

const Services = () => {
    const services = [
        {
            key: "supply",
            title: "Supply Only",
            icon: "boxes",
            description: "We source and deliver high‑quality ductwork and components to your site on schedule, ready for your team to install."
        },
        {
            key: "installation",
            title: "Installation Only",
            icon: "wrench",
            description: "Certified installers fit your supplied materials to specification with safe methods of work and on‑site coordination."
        },
        {
            key: "supply-install",
            title: "Supply and Installation",
            icon: "cogs",
            description: "End‑to‑end delivery: we procure, fabricate, and install a complete solution with a single point of accountability."
        }
    ];

    return (
        <Container className="services">
            <Grid doubling columns={2}>
                <Grid.Column width={6}>
                    <Header as="h3" content="Services" className="services-h3" />
                </Grid.Column>
                <Grid.Column width={10}>
                    <div className="services-list">
                        {services.map(({ key, title, icon, description }) => (
                            <div key={key} className="services-item">
                                <div className="services-icon" aria-label={`${title} icon`} role="img">
                                    <Icon name={icon} size="huge" />
                                </div>
                                <Header as="h4" className="services-title">{title}</Header>
                                <p className="services-desc">{description}</p>
                            </div>
                        ))}
                    </div>
                </Grid.Column>
            </Grid>
        </Container>
    );
};

export default Services;
